import { getParamsFromSessionStorage } from '@utils/storage';

import { LocationConfig } from '../../api/requests';

export enum PaymentMethodType {
  APPLE = 'apple',
  CARD = 'card',
  PAYPAL = 'paypal',
}

export type QuizData = {
  startDate: number | null;
  email: string;
  isPaymentModalOpen: boolean;
  selectedPaymentMethod: PaymentMethodType;
  firstName: string;
  lastName: string;
  birth_date: Date | null;
  name: string;
};

const { userQuizEmail } = getParamsFromSessionStorage(['userQuizEmail']);

export const DEFAUL_QUIZ_DATA: QuizData = {
  startDate: null,
  email: userQuizEmail ?? '',
  isPaymentModalOpen: false,
  selectedPaymentMethod: PaymentMethodType.CARD,
  firstName: '',
  lastName: '',
  birth_date: null,
  name: '',
};

export type QuizContextType = {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  quizData: QuizData;
  setQuizData: React.Dispatch<React.SetStateAction<QuizData>>;
  userLocation: LocationConfig | null;
};
